import React from 'react';
import moment from 'moment';
import { CloseIcon, EditIcon, UserIcon } from 'assets/icons';
import { Globals } from 'utils';

interface ModalViewPatientProps {
  user?: any
  onClose: () => void
  onEdit?: () => void
}

const ModalViewPatient = ({ user, onClose, onEdit }: ModalViewPatientProps) => {
  const yearsOld = moment().diff(moment(user?.birthdate), 'years');
  const photo = user?.photo ? Globals.fromStorage(user.photo) : UserIcon;

  return (
    <div>
      <button className="close-btn" onClick={onClose}>
        <img src={CloseIcon} alt="Cerrar" />
      </button>

      <section className="head">
        <div className="user-photo">
          <img src={photo} alt="Usuario" />
        </div>
        <div style={{ gridColumnStart: 2, gridColumnEnd: 4 }}>
          <div className="user-name">
            <p>{ user?.full_name }</p>
            {user?.birthdate && (<span>{ yearsOld } años</span>)}
          </div>
          <div className="actions">
            <button onClick={onEdit}>
              <img src={EditIcon} alt="Editar" />
              <span>Editar</span>
            </button>
          </div>
        </div>
      </section>

      <section className="body">
        <div className="details">
          <div className="created-at">
            <span>Fecha de registro: { moment(user?.created_at).format('DD-MM-YYYY') }</span>
          </div>
          <p>
            <label>Fecha de nacimiento:</label>
            <span> { user?.birthdate ? moment(user?.birthdate).format('DD-MM-YYYY') : 'No definida' }</span>
          </p>
          <p><label>C.I.:</label> { user?.full_document }</p>
          <p><label>Teléfono:</label> { user?.full_phone }</p>
          <p><label>Correo:</label> { user?.email }</p>
        </div>
      </section>
    </div>
  );
}

export default ModalViewPatient;